// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customizable-dashboard {
  padding: 24px;
  background: var(--bg-base);
  min-height: calc(100vh - 64px);
}

.customizable-dashboard .dashboard-header {
  margin-bottom: 32px;
  animation: fadeInDown 0.6s ease-out;
}

.customizable-dashboard .dashboard-header h1 {
  font-size: 32px;
  font-weight: 700;
  letter-spacing: -0.02em;
  background: var(--accent-grad);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  margin: 0 0 8px 0;
}

.customizable-dashboard .dashboard-header p {
  color: var(--text-muted);
  font-size: 16px;
  margin: 0;
}

.dashboard-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 64px);
  font-size: 16px;
  color: var(--text-secondary);
  background: var(--bg-base);
}

.customizable-dashboard .react-grid-layout {
  position: relative;
  margin-bottom: 20px;
}

.customizable-dashboard .react-grid-item {
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1),
              width 0.2s cubic-bezier(0.4, 0, 0.2, 1),
              height 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.customizable-dashboard .react-grid-item.react-grid-placeholder {
  background: var(--accent-glow);
  border: 1px dashed var(--accent);
  opacity: 1;
  border-radius: var(--radius-md);
  transition-duration: 100ms;
  z-index: 2;
  -webkit-user-select: none;
          user-select: none;
}

.customizable-dashboard .react-grid-item.resizing {
  opacity: 0.9;
  z-index: 3;
}

.customizable-dashboard .react-grid-item.react-draggable-dragging {
  opacity: 0.85;
  z-index: 4;
  transition: none;
}

.customizable-dashboard .react-grid-item > .react-resizable-handle {
  position: absolute;
  width: 20px;
  height: 20px;
  bottom: 0;
  right: 0;
  cursor: se-resize;
  z-index: 10;
}

.customizable-dashboard .react-grid-item > .react-resizable-handle::after {
  content: '';
  position: absolute;
  right: 3px;
  bottom: 3px;
  width: 6px;
  height: 6px;
  border-right: 2px solid var(--border-strong);
  border-bottom: 2px solid var(--border-strong);
  transition: border-color 0.15s ease;
}

.customizable-dashboard .react-grid-item:hover > .react-resizable-handle::after {
  border-right-color: var(--text-muted);
  border-bottom-color: var(--text-muted);
}

@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-20px); }
  to   { opacity: 1; transform: translateY(0); }
}

@media (max-width: 992px) {
  .customizable-dashboard { padding: 16px; }
  .customizable-dashboard .dashboard-header h1 { font-size: 24px; }
}

@media (max-width: 576px) {
  .customizable-dashboard { padding: 12px; }
  .customizable-dashboard .dashboard-header h1 { font-size: 20px; }
  .customizable-dashboard .dashboard-header p { font-size: 14px; }
}`, "",{"version":3,"sources":["webpack://./src/components/dashboard/CustomizableDashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,8BAA8B;EAC9B,6BAA6B;EAC7B,qBAAqB;EACrB,oCAAoC;EACpC,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;;sDAEoD;AACtD;;AAEA;EACE,8BAA8B;EAC9B,gCAAgC;EAChC,UAAU;EACV,+BAA+B;EAC/B,0BAA0B;EAC1B,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,WAAW;EACX,4CAA4C;EAC5C,6CAA6C;EAC7C,mCAAmC;AACrC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,0BAA0B,aAAa,EAAE;EACzC,+CAA+C,eAAe,EAAE;AAClE;;AAEA;EACE,0BAA0B,aAAa,EAAE;EACzC,+CAA+C,eAAe,EAAE;EAChE,8CAA8C,eAAe,EAAE;AACjE","sourcesContent":[".customizable-dashboard {\n  padding: 24px;\n  background: var(--bg-base);\n  min-height: calc(100vh - 64px);\n}\n\n.customizable-dashboard .dashboard-header {\n  margin-bottom: 32px;\n  animation: fadeInDown 0.6s ease-out;\n}\n\n.customizable-dashboard .dashboard-header h1 {\n  font-size: 32px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  background: var(--accent-grad);\n  -webkit-background-clip: text;\n  background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin: 0 0 8px 0;\n}\n\n.customizable-dashboard .dashboard-header p {\n  color: var(--text-muted);\n  font-size: 16px;\n  margin: 0;\n}\n\n.dashboard-loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: calc(100vh - 64px);\n  font-size: 16px;\n  color: var(--text-secondary);\n  background: var(--bg-base);\n}\n\n.customizable-dashboard .react-grid-layout {\n  position: relative;\n  margin-bottom: 20px;\n}\n\n.customizable-dashboard .react-grid-item {\n  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1),\n              width 0.2s cubic-bezier(0.4, 0, 0.2, 1),\n              height 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.customizable-dashboard .react-grid-item.react-grid-placeholder {\n  background: var(--accent-glow);\n  border: 1px dashed var(--accent);\n  opacity: 1;\n  border-radius: var(--radius-md);\n  transition-duration: 100ms;\n  z-index: 2;\n  user-select: none;\n}\n\n.customizable-dashboard .react-grid-item.resizing {\n  opacity: 0.9;\n  z-index: 3;\n}\n\n.customizable-dashboard .react-grid-item.react-draggable-dragging {\n  opacity: 0.85;\n  z-index: 4;\n  transition: none;\n}\n\n.customizable-dashboard .react-grid-item > .react-resizable-handle {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  bottom: 0;\n  right: 0;\n  cursor: se-resize;\n  z-index: 10;\n}\n\n.customizable-dashboard .react-grid-item > .react-resizable-handle::after {\n  content: '';\n  position: absolute;\n  right: 3px;\n  bottom: 3px;\n  width: 6px;\n  height: 6px;\n  border-right: 2px solid var(--border-strong);\n  border-bottom: 2px solid var(--border-strong);\n  transition: border-color 0.15s ease;\n}\n\n.customizable-dashboard .react-grid-item:hover > .react-resizable-handle::after {\n  border-right-color: var(--text-muted);\n  border-bottom-color: var(--text-muted);\n}\n\n@keyframes fadeInDown {\n  from { opacity: 0; transform: translateY(-20px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n@media (max-width: 992px) {\n  .customizable-dashboard { padding: 16px; }\n  .customizable-dashboard .dashboard-header h1 { font-size: 24px; }\n}\n\n@media (max-width: 576px) {\n  .customizable-dashboard { padding: 12px; }\n  .customizable-dashboard .dashboard-header h1 { font-size: 20px; }\n  .customizable-dashboard .dashboard-header p { font-size: 14px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
